// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__oXD8E","slider1":"slider_slider1__wJrlp","slider5":"slider_slider5__sINsy","slider6":"slider_slider6__Q5LJz"};